import { computed } from 'vue';
import { competitorSides } from '@/config/competitorSides';
import { useResultStore } from '@/modules/battles/stores/result';
import type { BattleCommentsType } from '@/modules/battles/interfaces';
import type { CompetitorSide } from '@/modules/battles/interfaces';

let leftColorState = competitorSides.RED as CompetitorSide;

export const useJudgePanelType = () => {
  const resultStore = useResultStore();

  const judgePanelType = computed(() => resultStore.currentJudgePanelType as BattleCommentsType);
  
  const leftColor = computed({
    get: () => leftColorState,
    set: (value: CompetitorSide) => {
      leftColorState = value;
    },
  });

  const setJudgePanelType = (value: BattleCommentsType | ((prev: BattleCommentsType) => BattleCommentsType)) => {
    if (typeof value === 'function') {
      const currentType = resultStore.currentJudgePanelType as BattleCommentsType;
      resultStore.setJudgePanelType(value(currentType));
    } else {
      resultStore.setJudgePanelType(value);
    }
  };

  const setLeftColor = (value: CompetitorSide | ((prev: CompetitorSide) => CompetitorSide)) => {
    if (typeof value === 'function') {
      leftColor.value = value(leftColor.value);
    } else {
      leftColor.value = value;
    }
  };

  return {
    judgePanelType,
    leftColor,
    setJudgePanelType,
    setLeftColor,
  };
};

